var mulberrySelectors = {
  pdpForm: "form[action='/cart/add']",
  paymentButtons: '.payment-buttons',
  openCartButton: '#nav-cart-btn'
}


async function removeAndSyncWarranties(reload=false) {
  await fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (cart) {
      cart.json().then(function (firstCart) {
        mulberryShop.removeDetachedWarranty(firstCart)// Remove Warranties First 
        .then(newCart => {
          mulberryShop.cart.syncQuantities(newCart)// Sync Quantities Second 
          .then(content => {
            if(reload){
              window.location.reload()
            }
            else {
              refreshCart()
//               setTimeout(function(){ mulberryShop.cart.render() }, 300);
//               setTimeout(function(){ mulberryShop.cart.render() }, 1000);
              if(content.item_count === 0){
                setTimeout(function(){ 
                  if($(".cart--continue-message").length === 0) {refreshCart()}
                }, 1000);
              }
            }
          })
        })
      });
    })
}



async function refreshCart() {
//   if($("#ajaxifyModal").attr('class').indexOf('is-visible') !== -1) {
    Shopify.getCart(window.cartUpdateCallback)
    setTimeout(function(){ mulberryShop.cart.render() }, 1000);
//   }
}




async function mulberryInit() {
  
  let mulberryDiv = document.createElement('div')
  mulberryDiv.classList.add('mulberry-inline-container')
  $(mulberrySelectors.paymentButtons).prepend(mulberryDiv)
  
  let response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
  let product = response.product;
  let selectedVariant = product.variants.find(i => i.id == mulberryShop.selectedVariantId)
  const offers = await mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: selectedVariant.price,
      detail: product
  })
  
  if(offers.length === 0){
    document.addEventListener("shopify:cart-add", function() {
      setTimeout(function(){ mulberryShop.cart.render() }, 650);
    })
    return
  }

  const { settings } = mulberry.core;
  let selectedOffer;
  
  
  if(offers[0].customer_cost === "0.99") {
    selectedIndex = 0
    selectedOffer = offers[0]
  }
  else {
    selectedIndex = null
  }

  let pdpInline = await mulberry.inline.init({
      offers: offers, 
      settings: mulberry.core.settings,
      selector: '.mulberry-inline-container',
      initialSelectedIndex: selectedIndex,
      onWarrantyToggle: async (warranty) => {
        mulberry.inline.isSelected = warranty.isSelected
        if(warranty.isSelected) {
          selectedOffer = warranty.offer
        }
        else {
          selectedOffer = null
        }
      }
    })
  
  let pdpModal = await mulberry.modal.init({
      offers: offers, 
      settings: mulberry.core.settings,
      onWarrantySelect: async (warranty) => {
        const result = await mulberryShop.getWarrantyVariant(warranty);
        await mulberryShop.addWarrantyToCart(result.shopify_variant_id, product, warranty);
        mulberry.modal.close();
        removeAndSyncWarranties()
      },
      onWarrantyDecline: () => {
        mulberry.modal.close();
        removeAndSyncWarranties()
      }
    })


  document.addEventListener('mulberry-shopify:variant-change', async function(e) {
    selectedVariant = product.variants.find(i => i.id == e.detail.variantId)
    const offers = await mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: selectedVariant.price,
      detail: product
    })

    pdpInline.updateOffer(offers);

  });
  
  $(mulberrySelectors.pdpForm).submit(async function(){

    if(selectedOffer) {
      setTimeout(async function(){
       pdpInline.deselectOffer()
       const result = await mulberryShop.getWarrantyVariant(selectedOffer);
       await mulberryShop.addWarrantyToCart(result.shopify_variant_id, product, selectedOffer);
       removeAndSyncWarranties()
       selectedOffer = null
      }, 250)  
    }
    else {
      pdpModal.open()
    }
  })
}




document.addEventListener('mulberry-shopify:warranty-added', () => {
  removeAndSyncWarranties();
});

document.addEventListener('mulberry-shopify:loaded', async () => {
 setupAjaxListeners()
 $(".header-cart-btn").on('click', function(){setTimeout(function(){ mulberryShop.cart.render() }, 650);})
 await mulberryShop.cart.init();
 mulberryShop.cart.render()
 
 if(document.location.href.search("products/") !== -1) {
    mulberryInit();
 }


  if (document.querySelector(mulberrySelectors.openCartButton)) {
      openCartEventListener()
  } else {
      setTimeout(function(){ openCartEventListener() }, 650);
  }

})


function setupAjaxListeners() {
    // Set up listeners to fire the pixel if/when the user peforms specific actions that trigger ajax requests.
    // Since we cant create globals we test for the XMLHttpRequest overwrite
    if (typeof XMLHttpRequest.prototype.mbOpen === 'undefined') {
        // We mock fetch() in order to determine if we should mock then() as well
        var mbFetch = fetch;
        fetch = function() {
            var url = arguments[0];
            var body = '';
            if ((arguments.length > 1) && (typeof arguments[1].body !== 'undefined'))
            {
                body = arguments[1].body;
            }
            var promise = mbFetch.apply(this,arguments);
            if (url && url.indexOf('cart/change') !== -1) {
                //If its a product being added to cart we add a function to track it
                promise = promise.then(function (response) {
                    if (response.ok) {
                        //trackAjaxAddToCart(body, response.clone().json());
                    }
                    return response;
                });
            }
            return promise;
        };
    }
    if (typeof XMLHttpRequest.prototype.mbOpen === 'undefined') {
        // We mock the XMLHttpRequest open method in order to determine if we should mock the send method
        XMLHttpRequest.prototype.mbOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function () {
            var url = arguments[1];
            if (url && ( (url.indexOf('cart/change') !== -1) || (url.indexOf('cart/add')) )) {
                // We mock the instance's send method if the request is to the "add to the cart" url.
                this.mbSend = this.send;
                this.send = function (value) {
                    try {
                        if (value) {
                            var self = this; // The xhttp request object

                            var trackOnSuccess = function () {
                                if (self.readyState === 4 && self.status === 200) {
                                  if(self.responseURL.indexOf('cart/add') !== -1){
                                    addCustomEvent = new CustomEvent("shopify:cart-add")
                                    document.dispatchEvent(addCustomEvent)
                                  }
                                  else {
                                    changeCustomEvent = new CustomEvent("shopify:cart-change")
                                    document.dispatchEvent(changeCustomEvent)
//                                     removeAndSyncWarranties()
                                    
                                  }
//                                     removeAndSyncWarranties()
                                }
                            };

                            if (typeof self.addEventListener !== 'undefined') {
                                self.addEventListener('readystatechange', trackOnSuccess);
                            } else {
                                if (typeof self.onreadystatechange !== 'undefined' && self.onreadystatechange !== null) {
                                    // If the xhttp object already has an onreadystatechange callback, make sure we preserve it.
                                    self.mbOnreadystatechange = self.onreadystatechange;
                                    self.onreadystatechange = function () {
                                        self.mbOnreadystatechange();
                                        trackOnSuccess();
                                    };
                                } else {
                                  // If there is no onreadystatechange callback, we can safely set it.
                                  self.onreadystatechange = trackOnSuccess;
                                }
                            }
                        }
                    } catch(e) {
                        // if something goes wrong tracking the addToCart,
                        // we just ignore it and prevent the website from breaking.
                        console.log(e);
                    }
                    this.mbSend(value);
                };
            }
            this.mbOpen.apply(this, arguments);
        };
    }
}


async function openCartEventListener() {
	setTimeout(function(){ mulberryShop.cart.render() }, 650);
  
    document.addEventListener('mulberry-shopify:cart-update', function() {
        setTimeout(function(){ mulberryShop.cart.render() }, 650);
    })
}
